<template>
	<div id="app">
		<div class="app-shell" v-if="showShell">
			<aside class="sidebar">
				<div class="brand">
					<span class="brand-icon">🔧</span>
					<span class="brand-text">CHANGNET</span>
				</div>

				<nav class="nav-list">
					<router-link to="/devices" class="nav-item">
						<span class="nav-icon">📱</span>设备管理
					</router-link>
					<router-link to="/timers" class="nav-item">
						<span class="nav-icon">⏰</span>定时任务
					</router-link>
					<router-link to="/groups" class="nav-item">
						<span class="nav-icon">🗂</span>设备分组
					</router-link>
					<router-link to="/profile" class="nav-item">
						<span class="nav-icon">👤</span>我的资料
					</router-link>
				</nav>

				<div class="sidebar-footer">
					<div class="user-info" v-if="userInfo">
						<div class="user-avatar">
							<img v-if="userInfo.avatar" :src="userInfo.avatar" alt="" />
							<span v-else>{{ (userInfo.nickname || '用').charAt(0) }}</span>
						</div>
						<span class="user-name">{{ userInfo.nickname || '未命名用户' }}</span>
					</div>
					<button class="logout-btn" @click="handleLogout">退出登录</button>
				</div>
			</aside>

			<main class="main-content">
				<router-view />
			</main>
		</div>

		<router-view v-else />
	</div>
</template>

<script>
export default {
	name: 'App',
	computed: {
		showShell() {
			return this.$route.name !== 'Login'
		},
		userInfo() {
			return this.$store.state.userInfo
		}
	},
	methods: {
		handleLogout() {
			this.$store.commit('logout')
			this.$router.replace('/login')
		}
	}
}
</script>

<style>
:root {
	--bg-page: #0f0f1e;
	--bg-card: #1a1a2e;
	--bg-card-alt: #16213e;
	--accent: #00d9ff;
	--accent-dark: #0099cc;
	--online: #07c160;
	--danger: #ff6464;
	--text-main: #ffffff;
	--text-sub: #999999;
	--text-faint: #666666;
	--border-soft: rgba(255, 255, 255, 0.1);
}

* { box-sizing: border-box; }

html, body {
	margin: 0;
	padding: 0;
	background: var(--bg-page);
	color: var(--text-main);
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

#app {
	min-height: 100vh;
}

.app-shell {
	display: flex;
	min-height: 100vh;
}

.sidebar {
	width: 220px;
	flex-shrink: 0;
	background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
	border-right: 1px solid var(--border-soft);
	display: flex;
	flex-direction: column;
	padding: 24px 0;
}

.brand {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 0 24px 24px;
	font-size: 18px;
	font-weight: 700;
	color: var(--accent);
	border-bottom: 1px solid var(--border-soft);
	margin-bottom: 16px;
}

.nav-list {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 0 12px;
}

.nav-item {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 12px 16px;
	border-radius: 8px;
	color: var(--text-sub);
	text-decoration: none;
	font-size: 14px;
	transition: background 0.2s, color 0.2s;
}

.nav-icon { font-size: 16px; }

.nav-item:hover {
	background: rgba(0, 217, 255, 0.06);
	color: var(--text-main);
}

.nav-item.router-link-active {
	background: rgba(0, 217, 255, 0.12);
	color: var(--accent);
	font-weight: 600;
}

.sidebar-footer {
	padding: 16px 20px 0;
	border-top: 1px solid var(--border-soft);
	margin-top: 16px;
}

.user-info {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 14px;
}

.user-avatar {
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background: rgba(0, 217, 255, 0.15);
	color: var(--accent);
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 700;
	overflow: hidden;
	flex-shrink: 0;
}

.user-avatar img { width: 100%; height: 100%; object-fit: cover; }

.user-name {
	font-size: 14px;
	color: var(--text-main);
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.logout-btn {
	width: 100%;
	padding: 10px 0;
	background: rgba(255, 100, 100, 0.08);
	border: 1px solid rgba(255, 100, 100, 0.25);
	color: var(--danger);
	border-radius: 8px;
	font-size: 13px;
	cursor: pointer;
}
.logout-btn:hover { background: rgba(255, 100, 100, 0.15); }

.main-content {
	flex: 1;
	min-width: 0;
	padding: 32px 40px;
	overflow-y: auto;
}

/* 通用卡片/按钮/表单元素，各页面复用 */
.card {
	background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
	border-radius: 16px;
	padding: 24px;
	box-shadow: 0 4px 20px rgba(0, 217, 255, 0.06);
}

.page-title {
	font-size: 24px;
	font-weight: 700;
	color: var(--text-main);
	margin: 0 0 24px;
}

.btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	padding: 10px 20px;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 600;
	border: none;
	cursor: pointer;
	transition: opacity 0.15s, transform 0.15s;
}
.btn:active { transform: scale(0.97); }
.btn:disabled { opacity: 0.5; cursor: not-allowed; }

.btn-primary {
	background: linear-gradient(135deg, #00d9ff 0%, #0099cc 100%);
	color: #ffffff;
}
.btn-secondary {
	background: rgba(255, 255, 255, 0.06);
	border: 1px solid var(--border-soft);
	color: var(--text-main);
}
.btn-danger {
	background: rgba(255, 100, 100, 0.1);
	border: 1px solid rgba(255, 100, 100, 0.3);
	color: var(--danger);
}

.input {
	width: 100%;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid var(--border-soft);
	border-radius: 8px;
	padding: 10px 14px;
	font-size: 14px;
	color: var(--text-main);
}
.input::placeholder { color: var(--text-faint); }
.input:focus { outline: none; border-color: rgba(0, 217, 255, 0.4); }

.modal-mask {
	position: fixed;
	top: 0; left: 0; right: 0; bottom: 0;
	background: rgba(0, 0, 0, 0.6);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
}

.modal-content {
	background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
	border-radius: 16px;
	width: 420px;
	max-width: 90vw;
	max-height: 80vh;
	overflow-y: auto;
	padding: 28px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.modal-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
}
.modal-title { font-size: 18px; font-weight: 700; color: var(--text-main); }
.modal-close { cursor: pointer; color: var(--text-sub); font-size: 18px; }
.modal-footer { display: flex; justify-content: flex-end; gap: 12px; margin-top: 24px; }
</style>
